import apiService from '../apiService';

export const addTagTypes = ['Subscriptions_List', 'Invoices_List', 'Active_Subscription'] as const;

export const applicationsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getSubscriptionsList: build.query({
				query: () => ({
					url: `subscription`
				}),
				providesTags: ['Subscriptions_List']
			}),
			getInvoicesList: build.query<any, any>({
				query: ({ starting_after, per_page, ...rest }) => ({
					url: `subscription/invoices`,
					params: {
						per_page,
						starting_after,
						...rest
					}
				}),
				providesTags: ['Invoices_List']
			}),
			getActiveSubscription: build.query({
				query: () => ({
					url: `subscription/active`
				}),
				providesTags: ['Active_Subscription']
			}),
			cancelSubscription: build.mutation({
				query: ({ subscriptionId, cancelAtPeriodEnd }) => ({
					url: 'subscription/cancel',
					method: 'POST',
					body: {
						subscription_id: subscriptionId,
						cancel_at_period_end: cancelAtPeriodEnd
					}
				}),
				invalidatesTags: ['Subscriptions_List']
			}),
			subscriptionCheckout: build.mutation({
				query: ({ planId }) => ({
					url: 'subscription/checkout',
					method: 'POST',
					body: {
						plan_id: planId
					}
				})
			})
		})
	});

export const {
	useGetSubscriptionsListQuery,
	useGetInvoicesListQuery,
	useGetActiveSubscriptionQuery,
	useCancelSubscriptionMutation,
	useSubscriptionCheckoutMutation
} = applicationsApi;
